<template>
  <div class='customer-image-header-container'>
    <t-header :class='{fixed: fixedHeader}'/>
    <div class='top-container'></div>
    <div class='bc'>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class='link' @click.native='redirect("/case")'>客户案例</el-breadcrumb-item>
        <el-breadcrumb-item class='link' @click.native='handleNavClick'>{{data.type}}</el-breadcrumb-item>
        <el-breadcrumb-item class='blue'>{{data.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <article class='artical-content'>
      <img class='logo' :src='data.image'/>
      <mavon-editor
        :value="data.markdown"
        :editable="false"
        :toolbarsFlag="false"
        :subfield="false"
        :boxShadow="false"
        previewBackground="#fff"
        placeholder=" "
        defaultOpen="preview"
        :imageClick="()=>{}"></mavon-editor>
    </article>
  </div>
</template>

<script>
import customerCases from '../../utils/customerCases';
import THeader from '../../components/header';
import imageHeaderMixin from '../../mixins/imageHeader';

export default {
  components: {
    THeader,
  },
  mixins: [imageHeaderMixin],
  props: {
    id: {
      required: true,
      type: [String, Number],
    }
  },
  data() {
    let current = {};
    let types = [];
    customerCases.forEach(item => {
      if (item.id === this.id) {
        current = item;
      }
      if (!types.includes(item.type)) {
        types.push(item.type);
      }
    })
    return {
      data: current,
      types,
    }
  },
  methods: {
    handleNavClick() {
      this.redirect(`/case#section${this.types.indexOf(this.data.type)}`)
    }
  },
}
</script>

<style lang="less" scoped>
.bc {
  width: 1050px;
  margin: 0 auto;
  padding: 30px 0;
  /deep/ .el-breadcrumb__inner {
    font-size: 16px;
    color: #999;
  }
  /deep/ .blue .el-breadcrumb__inner {
    color: #718EFF;
  }
  /deep/ .link .el-breadcrumb__inner {
    cursor: pointer;
  }
}
.artical-content {
  width: 1050px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  .logo {
    width: 150px;
  }
}
</style>